import {
  faBuilding,
  faFileInvoiceDollar,
  faUser,
  faUsers,
  faCalendarAlt,
  faFileAlt,
  faHome,
  faLayerGroup,
  faAddressCard,
  faTasks,
  faSearch,
  faArrowUp,
  faArrowDown,
  faExclamationTriangle,
  faRedo,
  faHandHoldingUsd,
  faMoneyCheckAlt,
  faTachometerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { message } from "../../../../../../Utils/config/messages";

export const GLOBAL_SEARCH = {
  TEMPLATE_STORAGE_KEY: "searchTemplateNewData",
  MIN_CHARS: 2,
  DEBOUNCE_MS: 500,
  ALL_TAB: "all",
  FOCUS_DELAY_MS: 60,
  SCROLL_BLOCK: "nearest",
};

export const RECENT = {
  STORAGE_KEY: "globalSearch.recent",
  MAX: 5,
  GROUP_KEY: "recent",
};

export const SEARCH_STRINGS = {
  PLACEHOLDER: message.SEARCH_PLACEHOLDER,
  ALL_TAB: message.SEARCH_ALL_TAB,
  NO_RESULTS: message.SEARCH_NO_RESULTS,
  NO_RESULTS_HINT: message.SEARCH_NO_RESULTS_HINT,
  IDLE_HINT: message.SEARCH_IDLE_HINT,
  QUICK_LINKS: message.SEARCH_QUICK_LINKS,
  SEARCHING: message.SEARCH_SEARCHING,
  ERROR: message.SEARCH_ERROR,
  TRIGGER: message.SEARCH_TRIGGER_LABEL,
  NAVIGATE: message.SEARCH_FOOTER_NAVIGATE,
  OPEN: message.SEARCH_FOOTER_OPEN,
  CLOSE: message.SEARCH_FOOTER_CLOSE,
  SWITCH: message.SEARCH_FOOTER_SWITCH,
  RECENT: message.SEARCH_RECENT,
  RECENT_CLEAR: message.SEARCH_RECENT_CLEAR,
  MIN_CHARS_HINT: message.SEARCH_MIN_CHARS_HINT,
  RETRY: message.SEARCH_RETRY,
};

export const SEARCH_KEYS = {
  ARROW_DOWN: "ArrowDown",
  ARROW_UP: "ArrowUp",
  ENTER: "Enter",
  ESCAPE: "Escape",
  TAB: "Tab",
  HOTKEY_LETTERS: ["k", "K"],
};

export const KEY_LABELS = {
  ESCAPE: "Esc",
  HOTKEY: "K",
  TAB: "Tab",
};

export const PLATFORM = {
  MAC_REGEX: /Mac|iPhone|iPad|iPod/,
  MAC_MODIFIER: "⌘",
  DEFAULT_MODIFIER: "Ctrl",
};

export const MODIFIER_KEY =
  typeof navigator !== "undefined" &&
  PLATFORM.MAC_REGEX.test(navigator.platform || navigator.userAgent || "")
    ? PLATFORM.MAC_MODIFIER
    : PLATFORM.DEFAULT_MODIFIER;

export const ENTITY_DEFAULTS = {
  KEY: "other",
  LABEL: "Other",
};

export const ENTITY_ORDER = [
  "loan",
  "borrower",
  "company",
  "client",
  "investment",
  "contact",
  "meeting",
];

export const RECORD_FIELDS = {
  HEADING: "heading",
  SUB_HEADING: "subHeading",
};

export const DEFAULT_HIGHLIGHT_FIELDS = [
  RECORD_FIELDS.HEADING,
  RECORD_FIELDS.SUB_HEADING,
];

export const HIGHLIGHT_FIELDS = {
  loan: [RECORD_FIELDS.HEADING, RECORD_FIELDS.SUB_HEADING],
  borrower: [RECORD_FIELDS.HEADING],
};


export const QUICK_LINKS = [
  {
    id: "ql-home",
    heading: "Home",
    iconKey: "home",
    isQuickLink: true,
    route: "/home/e79fd120-30ed-46eb-b4b1-54b43b9d1d14/19ce9808-de97-4c75-9089-0df544835f7c",
  },
  {
    id: "ql-faTachometerAlt",
    heading: "Operational Efficiency",
    iconKey: "Operational Efficiency",
    isQuickLink: true,
    route: "/home/e79fd120-30ed-46eb-b4b1-54b43b9d1d14/6cd73445-b92a-463d-9efd-0b20138c42db",
  },
  {
    id: "ql-borrower-profiles",
    heading: "Borrower Details",
    iconKey: "profiles",
    isQuickLink: true,
    route: "/home/e79fd120-30ed-46eb-b4b1-54b43b9d1d14/7c4c2a6f-21de-4c67-bab9-fe45a85c37de",
  },
];

export const QUICK_LINK_GROUP_KEY = "quicklinks";

export const QUICK_LINK_GROUPS = [
  {
    key: QUICK_LINK_GROUP_KEY,
    label: SEARCH_STRINGS.QUICK_LINKS,
    items: QUICK_LINKS,
  },
];

export const SEARCH_ICONS = {
  borrower: faHandHoldingUsd,
  company: faBuilding,
  client: faBuilding,
  loan: faMoneyCheckAlt,
  investment: faFileInvoiceDollar,
  contact: faUser,
  meeting: faCalendarAlt,
  home: faHome,
  exposure: faLayerGroup,
  // getIcon() lowercases the lookup key, so every key here must be lowercase
  "operational efficiency": faTachometerAlt,
  profiles: faAddressCard,
  tasks: faTasks,
  users: faUsers,
};

export const DEFAULT_SEARCH_ICON = faFileAlt;

export const SEARCH_UI_ICONS = {
  SEARCH: faSearch,
  NAV_UP: faArrowUp,
  NAV_DOWN: faArrowDown,
  ERROR: faExclamationTriangle,
  RETRY: faRedo,
};

export const SKELETON = {
  ROWS: [0, 1, 2, 3],
  ICON_SIZE: 34,
  TITLE_HEIGHT: 14,
  SUB_HEIGHT: 12,
  TITLE_WIDTH: "55%",
  SUB_WIDTH: "35%",
};

export const SEARCH_STYLE = {
  backdropColor: "rgba(15, 23, 42, 0.42)",
  backdropBlur: "blur(7px) saturate(120%)",
  paletteMarginTop: "11vh",
  paletteWidth: "min(640px, 94vw)",
  paletteMaxHeight: "72vh",
  paletteRadius: "calc(16px * var(--app-radius-scale, 1))",
  paletteBg: "color-mix(in srgb, var(--color-background-paper) 68%, transparent)",
  paletteBlur: "blur(40px) saturate(180%)",
  paletteBorder: "1px solid rgba(255, 255, 255, 0.22)",
  paletteShadow:
    "0 24px 64px rgba(15, 23, 42, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.4), inset 0 0 0 1px rgba(255, 255, 255, 0.06)",
  paletteSheen:
    "linear-gradient(180deg, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0.06) 30%, rgba(255,255,255,0) 58%, rgba(0,0,0,0.05) 100%)",
  paletteSpecular:
    "linear-gradient(135deg, rgba(255,255,255,0.20) 0%, rgba(255,255,255,0) 28%, rgba(255,255,255,0) 72%, rgba(255,255,255,0.10) 100%)",
  glassDivider:
    "1px solid color-mix(in srgb, var(--color-text-primary) 12%, transparent)",
  kbdGlassBg: "color-mix(in srgb, var(--color-background-paper) 55%, transparent)",
  kbdGlassBorder:
    "1px solid color-mix(in srgb, var(--color-text-primary) 16%, transparent)",
  tabActiveSheen:
    "linear-gradient(180deg, rgba(255,255,255,0.30) 0%, rgba(255,255,255,0.08) 45%, rgba(255,255,255,0) 75%)",
  tabActiveShadow:
    "0 6px 18px color-mix(in srgb, var(--color-primary-main) 40%, transparent), inset 0 1px 0 rgba(255, 255, 255, 0.38)",
  paletteMarginTopXs: "4vh",
  paletteMaxHeightXs: "88vh",
  pillRadius: 999,
  kbdRadius: 6,
  avatarSize: 28,
  avatarIconSize: "1.125rem",
  enterHintSize: 20,
  tabCountMinWidth: 18,
  kbdMinWidth: 18,
  tagChipMaxWidth: 160,
  triggerMinWidth: 170,
  rowActiveBorderWidth: 3,
  tabCountBg: "rgba(255, 255, 255, 0.2)",
  tagChipBg: "color-mix(in srgb, var(--color-primary-main) 14%, transparent)",
  highlightBg: "color-mix(in srgb, var(--color-primary-main) 22%, transparent)",
  tagChipBorder:
    "1px solid color-mix(in srgb, var(--color-primary-main) 30%, transparent)",
  triggerBg:
    "linear-gradient(135deg, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0.07) 100%)",
  triggerBgHover:
    "linear-gradient(135deg, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0.11) 100%)",
  triggerBorder: "1px solid rgba(255,255,255,0.22)",
  triggerBorderHover: "rgba(255,255,255,0.32)",
  triggerBlur: "blur(16px) saturate(160%)",
  triggerColor: "rgba(255,255,255,0.86)",
  triggerKbdBg: "rgba(255,255,255,0.16)",
  triggerKbdBorder: "1px solid rgba(255,255,255,0.22)",
  transitionRow: "background 0.12s ease",
  transitionTab: "background 0.15s ease, color 0.15s ease",
  transitionTrigger: "background 0.2s ease, border-color 0.2s ease",
  fontHeaderIcon: "1.0625rem",
  fontInput: "1.0625rem",
  fontTab: "0.75rem",
  fontMicro: "0.6875rem",
  fontHeading: "0.9375rem",
  fontSubHeading: "0.75rem",
  fontChip: "0.625rem",
  fontEnterHint: "0.8125rem",
  fontStateIcon: "2rem",
  fontStateTitle: "0.9375rem",
  fontStateHint: "0.8125rem",
  fontTrigger: "0.875rem",
  fontTriggerIcon: "0.875rem",
};
